import { inject, observer } from 'mobx-react';

const MobileInsideChats = () => {
    return <>GRT移动端内部智能体会话页</>;
};

export default inject('store')(observer(MobileInsideChats));
